import { render } from "./PersonalData.vue?vue&type=template&id=4207550c"
const script = {}

import "./PersonalData.vue?vue&type=style&index=0&id=4207550c&lang=css"

import exportComponent from "/Users/macbook13dbs1/Documents/Vue/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__